import React from "react";

const InfoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#8B929A"
      d="M9 16.875a7.875 7.875 0 1 1 0-15.75 7.875 7.875 0 0 1 0 15.75ZM9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z"
    />
    <path
      fill="#8B929A"
      d="m10.047 7.411-2.577.323-.093.429.508.092c.33.08.395.198.323.527l-.83 3.903c-.218 1.008.118 1.483.909 1.483.613 0 1.325-.284 1.648-.672l.099-.468c-.224.197-.554.276-.771.276-.31 0-.422-.217-.343-.6l1.127-5.293ZM10.125 5.063a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z"
    />
  </svg>
);
export default InfoIcon;
